import { CmsComponents } from '../ComponentRecognizer/ComponentRecognizer';
import type { CmsData, MenuType } from '../../../interfaces';
import { registerFlexibleComponents } from '../ComponentRecognizer/registerFlexibleComponents';
import { ContentWithMenu } from './ContentWithMenu.client';
import { SchemaOrg } from '../SchemaOrg/SchemaOrg';
import { ClientRegistration } from './ClientRegistration.client';

const contentWidthStyle = {
  standard: '[--shop-max-width:71.25rem]',
  wide: '[--shop-max-width:90rem]',
  wider: '[--shop-max-width:105rem]',
  widest: '[--shop-max-width:121.25rem]',
  full: '[--shop-max-width:100vw] lg:-ml-1 lg:w-[calc(100%+1rem)]',
} as const;

export const Content = ({
  data,
  menuData,
  token,
}: {
  data: CmsData;
  menuData?: MenuType;
  token?: string;
}) => {
  // Register components for server-side rendering (guarded to run only once)
  registerFlexibleComponents();
  const pageTemplate = data.type === 'storefront_content' ? 'homepage' : 'ServiceUndHilfe';

  const { field_maximum_content_width: contentWidth = 'standard' } = data;

  const content = (
    <CmsComponents paragraphs={data.paragraph} pageTemplate={pageTemplate} token={token} />
  );

  return (
    <div
      className={`shop-content ${contentWidthStyle[contentWidth] ?? contentWidthStyle.standard}`}
    >
      <ClientRegistration />
      <SchemaOrg data={data} />
      {menuData ? (
        <ContentWithMenu menuData={menuData} currentPath={data.path?.[0].alias}>
          {content}
        </ContentWithMenu>
      ) : (
        content
      )}
    </div>
  );
};
